import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/workspace/src/components/ui/separator.tsx");
